// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 392) return "static/chunks/392-9d633a1951757562.js";
	if (chunkId === 769) return "static/chunks/769-40868fc1fc22e865.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"59":"c60e392e7fcad3fd","151":"d76973fea0dd9b46","215":"78725f298db9c74f","237":"da427f2b402378a9","412":"ec7a8ba8bea01ca0","625":"f45230141d50f18d"}[chunkId] + ".js";
};